<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <!--<div class="btn btn-default btn-table-title">匯出表單</div>-->
          <select class="form-control h-38" v-model="processSelect">
            <option value="99">== 處理狀態 ==</option>
            <option value="1">已處理</option>
            <option value="0">未處理</option>
          </select>
        </div>
        <br>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1">時間</option>
          </select>
        </div>
        <div class="form-group input-group time-box" v-if="searchSelect == 1">
          <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
          <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
          <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
          <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
          <span class="input-group-btn">
            <button class="btn btn-default submit-btn btn-search" type="button"
                    id="search" style="height: 72px" @click="getAbnormalOrderList('search')">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單編號</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">ID</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99">品牌(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99 || roleType === 30">分店(ID)</th>
            <!-- :TODO 將改成手機帳號ID-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂購者<span v-if="roleType === 99">(ID)</span></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">電話</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">取餐類型</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總數</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">總額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">處理狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">下訂時間</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款方式</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機編號(收銀機代號)</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機交易序號</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">pos機取餐號</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>-->
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="orderList.length > 0">
          <tr class="even" role="row" v-for="(order, index) in orderList">
            <td class="sorting_1">{{index + 1}}</td>
            <td>
              <router-link :to="{path: '/orderInfo/' + order.order_id}" target="_blank">{{order.order_sn}}</router-link>
            </td>
            <!--<td>{{order.order_id}}</td>-->
            <td>
              <label class="label" :class="orderStateColor(order.status)">{{orderState(order.status)}}</label>
            </td>
            <td>
              <span v-if="order.order_type === 1" class="label label-primary">一般單</span>
              <span v-if="order.order_type === 2" class="label label-warning">團購單</span>
            </td>
              <td v-if="roleType === 99">{{order.brand_name}}({{order.brand_id}})</td>
              <td v-if="roleType === 99 || roleType === 30">{{order.store_name}}({{order.store_id}})</td>
            <td>
              <span v-if="roleType !== 99 || $route.name == 'memberOrderTable'">{{order.name}}<span v-if="roleType === 99">({{order.shopper_id}})</span></span>
              <router-link target="_blank" :to="{path: '/memberOrderTable/' + order.shopper_id}"  v-if="roleType === 99 && $route.name !== 'memberOrderTable'">{{order.name}}({{order.shopper_id}})</router-link>
            </td>
            <td>{{order.phone}}</td>
            <!--<td>{{order.delivery_type | deliveryName}}</td>-->
            <td>{{order.amount}}</td>
            <td>＄{{order.money}}</td>
            <td>{{payStateName(order.payment_status)}}</td>
            <td>
              <span v-if="order.is_processed" class="label label-success">已處理</span>
              <span v-if="!order.is_processed"  class="label label-danger">未處理</span>
            </td>
            <td>{{getTime(order.order_time)}}</td>
            <!--<td>{{payType(order.pay_place_type)}}</td>-->
            <!--<td><span v-if="order.pos_order_sn">{{order.pos_order_sn}}({{order.pos_cashier_no}})</span></td>-->
            <!--<td>{{order.pos_order_no}}</td>-->
            <!--<td>{{order.pos_take_no}}</td>-->
            <!--<td>{{order.update_time}}</td>-->
            <!--<td>{{order.create_time}}</td>-->
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default{
  name: 'OrderExceptionTableTemp',
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: 0,
      total: 0,
      orderList: [],
      show: {
        brand: false,
        menu: false,
        schedule: false
      },
      count: 20,
      orderSn: '',
      shopper: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      processSelect: 99,
      timeSearch: false,
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      isLoading: true
    }
  },
  methods: {
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '尚未付款'
      } else if (state === 12) {
        return '付款處理中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款處理中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderStateColor (state) {
      switch (state) {
        case 140: // 已作廢
        case 120: // 被店家退訂
        case 121: // 被系統退訂
        case 122: // 已取消
        case 99: // 使用者取消訂單
          return 'label-danger'
        case 100: // 未接單
          return 'label-default'
        case 110: // 已接單
          return 'label-primary'
        case 130: // 已完成
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '客人取消'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '店家退訂'
      } else if (state === 121) {
        return '系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getAbnormalOrderList()
    },
    getAbnormalOrderList (type) {
      this.isLoading = true
      var self = this
      if (type) {
        this.tableIndex = 1
        this.pageGroup = 1
        this.timeSearch = true
      }
      const data = {
        page: this.tableIndex,
        count: this.count,
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        order_sn: this.orderSn,
        shopper_name: this.shopper
      }
      var urlType = ''
      if (parseInt(this.getRoleType, 10) === 99) urlType = 'abnormalOrderList'
      else if (parseInt(this.getRoleType, 10) === 30) urlType = 'brandAbnormalOrderList'
      else if (parseInt(this.getRoleType, 10) === 10) urlType = 'storeAbnormalOrderList'
      var url
      if (parseInt(this.searchSelect, 10) === 1) {
        // use time search
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count
      } else if (parseInt(this.searchSelect, 10) === 2 && data.order_sn) {
        // use order sn search
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count + '&order_sn=' + data.order_sn
      } else if (parseInt(this.searchSelect, 10) === 3 && data.shopper_name) {
        // use order sn search
        url = '/order/' + urlType + '?page=' + data.page + '&size=' + data.count + '&shopper_name=' + data.shopper_name
      }
      if (parseInt(this.processSelect, 10) !== 99) url = url + '&is_processed=' + this.processSelect
      if (this.timeSearch) url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.orderList = response.data.order_list
            self.total = response.data.total
            self.isLoading = false
          }
        })
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm')
    }
  },
  created () {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).format('YYYY-MM-DD')
    if (this.$route.name === 'brandTable') this.show.brand = true
    else if (this.$route.name === 'menuTable') this.show.menu = true
    else if (this.$route.name === 'scheduleTable') this.show.schedule = true
    this.getAbnormalOrderList('search')
    this.roleType = parseInt(this.getRoleType, 10)
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    },
    processSelect () {
      this.getAbnormalOrderList()
    }
  }
}
</script>
<style lang="sass" scoped>
  .time-box
    max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
  @media screen and (max-width: 768px)
    #start-box, #end-box
      width: calc(100vw - 90px)
    .time-box
      max-width: calc( 100vw - 20px)
</style>



// WEBPACK FOOTER //
// OrderExceptionTableTemp.vue?78a4e3cb